module.exports = __webpack_public_path__ + "08f1fc6cca8a8fd9671dbb606e0bff15.svg";